// Model.js
// -----------------------
// @module Case
define("DC.CategoryCustomization.Description.SS2Model", ["Backbone", "Utils"], function(
    Backbone,
    Utils
) {
    "use strict";

    // @class Case.Fields.Model @extends Backbone.Model
    return Backbone.Model.extend({
        //@property {String} urlRoot
        urlRoot: Utils.getAbsoluteUrl(
            getExtensionAssetsPath(
                "Modules/Description/SuiteScript2/Description.Service.ss"
            ),
            true
        )
});
});
